var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.to)?_c('n-link',{attrs:{"to":_vm.to}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_c('span',[_vm._v("\n    "+_vm._s(_vm.value)+"\n    "),(!_vm.value && _vm.col.dashIfEmpty)?[_c('span',{staticClass:"text-muted"},[_vm._v("—")])]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }